import {
   GET_GENERAL_CONCEPTS,
   CHANGE_INPUT_VALUE_GENERAL,
   SAVE_GENERAL_CONCEPT,
   GET_INFO_GENERAL_CONCEPT,
   DELETE_GENERAL_CONCEPT,
   GENERAL_CONCEPT_DEFAULT_DATA
} from '../constants/general_concepts';

export const general_concepts = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_GENERAL_CONCEPTS : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_GENERAL : {
         return action.payload;
      }

      case SAVE_GENERAL_CONCEPT : {
         return action.payload;
      }

      case GET_INFO_GENERAL_CONCEPT : {
         return action.payload;
      }

      case DELETE_GENERAL_CONCEPT : {
         return action.payload;
      }

      case GENERAL_CONCEPT_DEFAULT_DATA : {
         return action.payload;
      }
 
     default :
     return state;
   }
}